module.exports = __webpack_public_path__ + "img/11.3bab9e50.png";